import { useState,useEffect,useRef } from 'react'; 
import MovingMarker from './OpenMap/MovingMarker';
import { BrowserRouter as Router} from 'react-router-dom';
import axios from 'axios'; 
import 'leaflet/dist/leaflet.css';   
import 'leaflet/dist/images/marker-icon-2x.png';
import 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/images/marker-shadow.png';
import GoogleMap from './GoogleMap/GoogleMap'; 
import OpenMap from './OpenMap/OpenMap';
  
const API_URL_FO=window.config.API_URL_FO+"Manifest/Coordinates/"; 
 
const LiveTrafficStatus = () => {
    const [liveDotPositionGoogle, setLiveDotPositionGoogle] = useState({});
    const [liveDotPositionOpen, setLiveDotPositionOpen] = useState([]);
    const [initialMarkersGoogle, setinitialMarkersGoogle]=useState([]);
    const [initialMarkersOpen, setinitialMarkersOpen]=useState([]);
    const intervalRef = useRef(null);
    const [Mapcenter, setMapCenter]=useState({});  
    const getCenter = (markers) => {
       if (!markers || markers.length === 0) return { lat: 39.6243, lng: 19.9217 };  

       const sums = markers.reduce((acc, marker) => {
       return {
            lat: acc.lat + parseFloat(marker.lat),
            lng: acc.lng + parseFloat(marker.lng)
        };
        }, { lat: 0, lng: 0 });

        return {
           lat: sums.lat / markers.length,
           lng: sums.lng / markers.length
        };
    };
 
    const fetchData = async (ordernum) => { 
            if (ordernum.length > 0){
                try { 
                let url = API_URL_FO+ ordernum;   
                    axios.get(url)
                            .then(response => { 
                                console.log('Data fetched successfully:', response.data);

                                const formattedMarkersGoogle = response.data.points.map(point => ({
                                    id: point.id,
                                    lat: parseFloat(point.latitude), 
                                    lng: parseFloat(point.longitude),  
                                    serviced: point.serviced 
                                }));

                                setinitialMarkersGoogle(formattedMarkersGoogle);
                                 
                                if (response.data.vehicle !== undefined){
                                     setLiveDotPositionGoogle({
                                        lat: parseFloat(response.data.vehicle.latitude),
                                        lng: parseFloat(response.data.vehicle.longitude),
                                        unitlabel:response.data.vehicle.unitLabel
                                     });  
                                }
                                
                                setMapCenter(getCenter(formattedMarkersGoogle));

                                const formattedMarkersOpen = response.data.points.map(point => ({
                                    name: point.id,
                                    position:[parseFloat(point.latitude),parseFloat(point.longitude)] ,
                                    serviced:point.serviced
                                }));

                                setinitialMarkersOpen(formattedMarkersOpen); 
                                if (response.data.vehicle !== undefined){
                                    setLiveDotPositionOpen([parseFloat(response.data.vehicle.latitude),parseFloat(response.data.vehicle.longitude)]);
                                }
                                   
                            })
                            .catch(error => {
                            console.error('Request failed:', error);
                            });  
                } catch (err) {
                console.error("API Polling Error:", err); 
                } finally {  
                }
            } 
    };

    // const goclicked =  () => {  
    //      const ordernum = document.getElementById('ordernumfilter').value;
    //      if (intervalRef.current) {
    //         clearInterval(intervalRef.current);
    //         intervalRef.current = null;  
    //     }
    //     fetchData(ordernum); 
    //     intervalRef.current = setInterval(() => {
    //         fetchData(ordernum);
    //     }, 4000); 
    // };  

// const logout= ()=>{
//     localStorage.setItem('isLoggedIn', 'false');
//     localStorage.removeItem('AccountID');  
//     localStorage.removeItem('isAdmin');
//     navigate('/');
// }

useEffect(() => {  
 
        const queryString = window.location.search; 
        const urlParams = new URLSearchParams(queryString); 
        const ordernum = urlParams.get('ordernum');

        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;  
        }
        fetchData(ordernum); 
        intervalRef.current = setInterval(() => {
            fetchData(ordernum);
        }, 4000);

        return () => {
            if (intervalRef.current) {
                console.log("Cleaning up interval before leaving...");
                clearInterval(intervalRef.current);
            }
        };
    }, []);

return ( 
          <div> 
            {/* <div className="date-filter-container">
                    <label   className="header-label">
                        Order Num
                    </label>
                    <input  Id="ordernumfilter"></input>
                    <button className="go-button" onClick={goclicked}>GO</button>
                </div> */}
            {window.config.isgoogle ? 
            ( 
                 <GoogleMap initialMarkers={initialMarkersGoogle} liveDotPosition={liveDotPositionGoogle} center={Mapcenter} ></GoogleMap>
            )
            :
            (
                <OpenMap markerData={initialMarkersOpen} redDotPosition={liveDotPositionOpen} center={Mapcenter} ></OpenMap> 
            )
            }
           {/* <div className='row'   align='right'> 
                <div className='logout-buttondiv'>
                    <button onClick={logout} className="logout-button">
                        <i className="fas fa-sign-out-alt"></i> LogOut
                    </button>
                </div> 
            </div> */}
          </div>
        );
    } 
 
export default LiveTrafficStatus;